import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { askConfirmName, lockError } from "../../lib/confirmName";

// 🛡️ Alertes « mélange » : abonnement payé avec une carte au nom d'une autre personne (prélèvements suspendus si nom d'un autre client)
export function MismatchAlerts() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/ops/stripe-ai/mismatch-alerts").then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (!rows) return null;
  const open = rows.filter((r) => !r.resolved);
  const resume = async (a) => {
    const confirm_name = askConfirmName("Reprendre les prélèvements — c'est bien ce client", a.customer_name);
    if (!confirm_name) return;
    try { await api.post(`/ops/stripe-ai/mismatch-alerts/${a.id}/decide`, { action: "resume", confirm_name }); toast.success("Prélèvements repris — nom de carte autorisé pour ce dossier"); load(); }
    catch (e) { toast.error(lockError(e)); }
  };
  return (
    <section className={`rounded-xl border p-4 ${open.length ? "border-rose-500/60 bg-rose-500/[0.07]" : "border-zinc-800 bg-zinc-900/40"}`} data-testid="mismatch-alerts">
      <div className="flex items-center justify-between">
        <h3 className="font-bold text-zinc-100">🛡️ Alertes mélange (carte ≠ fiche) <span className="text-xs text-zinc-400">— {open.length} à décider</span></h3>
        <button onClick={load} className="text-xs px-2 py-1 rounded bg-zinc-800 text-zinc-300" data-testid="mismatch-refresh">↻</button>
      </div>
      <p className="text-[11px] text-zinc-400 mt-1">Dès qu'un abonnement est créé avec une carte au nom d'un AUTRE client connu, ses prélèvements sont suspendus et Ralph reçoit un SMS. Rien n'est chargé tant que tu n'as pas décidé.</p>
      {!rows.length && <p className="text-xs text-zinc-500 mt-2">Aucune alerte.</p>}
      <div className="mt-2 space-y-2">
        {rows.slice(0, 20).map((a) => (
          <div key={a.id} className={`text-xs border rounded p-2 ${a.resolved ? "border-zinc-800 text-zinc-500" : a.blocked ? "border-rose-500/50 text-zinc-100" : "border-amber-500/40 text-zinc-200"}`} data-testid={`mismatch-row-${a.id}`}>
            <div className="flex flex-wrap items-center gap-2">
              <span className={`px-1.5 py-0.5 rounded font-bold ${a.blocked ? "bg-rose-700 text-white" : "bg-amber-600/40 text-amber-100"}`}>{a.blocked ? "BLOQUÉ" : "À vérifier"}</span>
              <span>Fiche <b>{a.customer_name}</b> ({a.customer_email}) · carte au nom de <b>{a.card_name}</b> ****{a.card_last4}</span>
              {a.other_client && <span className="text-rose-200">= client connu : {a.other_client.full_name}</span>}
              <span className="text-zinc-500 ml-auto">{a.at?.slice(0, 16).replace("T", " ")}</span>
            </div>
            {!a.resolved && (
              <div className="mt-1.5 flex gap-2">
                <button onClick={() => resume(a)} className="px-2 py-1 rounded bg-emerald-700 text-white font-semibold" data-testid={`mismatch-resume-${a.id}`}>✔ C'est bien lui — reprendre les prélèvements</button>
                <span className="text-zinc-400 self-center">Mauvaise fiche ? → « Annuler » dans Santé Stripe (verrou nom)</span>
              </div>
            )}
            {a.resolved && <div className="mt-1">Décision : {a.decision} · {a.by} · {a.resolved_at?.slice(0, 10)}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
